import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { useAppDispatch } from '@/app/store/hooks';
import type { ApiError } from '@/entities/api-response/types';

import { logout } from '../api/logout';
import { sessionCleared } from '../model/auth.slice';

export function useLogout(): UseMutationResult<void, ApiError> {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSettled: () => {
      // Limpiar SIEMPRE — incluso si el server falla, en cliente cerramos sesión.
      dispatch(sessionCleared());
      queryClient.clear();
    },
  });
}
